<div class="ciu" data-testid="ci-users">
  <p class="ciu__intro" data-testid="ci-users-intro">{{ 'classicImport.users.intro' | translate }}</p>

  @if (loading()) {
    <p class="ciu__state" role="status" data-testid="ci-users-loading">
      {{ 'classicImport.users.loading' | translate }}
    </p>
  } @else if (loadFailed()) {
    <div class="ciu__error" role="alert" data-testid="ci-users-load-error">
      <span>{{ 'classicImport.users.loadError' | translate }}</span>
      <button type="button" class="ciu__retry" data-testid="ci-users-retry" (click)="retry.emit()">
        {{ 'classicImport.users.retry' | translate }}
      </button>
    </div>
  } @else if (allMapped()) {
    <app-success-banner data-testid="ci-users-all-mapped" messageKey="classicImport.users.allMapped" />
  }

  <table class="ciu__table">
    <thead>
      <tr>
        <th scope="col">{{ 'classicImport.users.colClassic' | translate }}</th>
        <th scope="col">{{ 'classicImport.users.colPerson' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      @for (q of userQuestions(); track q.id) {
        <tr [attr.data-testid]="'ci-users-row-' + q.element">
          <td class="ciu__text">{{ q.text }}</td>
          <td class="ciu__person">
            <app-person-select
              [ngModel]="answers()[q.id] ?? ''"
              (ngModelChange)="choose(q.id, $event)"
              [options]="options()"
              [allowNone]="true"
              noneKey="classicImport.users.none"
              placeholderKey="classicImport.users.none"
              [label]="'classicImport.users.personLabel' | translate: { text: q.text }"
            />
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
